var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 15C7.125 15 7.5 14.625 7.5 14.1666V5.83329C7.5 5.37496 7.125 4.99996 6.66667 4.99996C6.20833 4.99996 5.83333 5.37496 5.83333 5.83329V14.1666C5.83333 14.625 6.20833 15 6.66667 15ZM10 18.3333C10.4583 18.3333 10.8333 17.9583 10.8333 17.5V2.49996C10.8333 2.04163 10.4583 1.66663 10 1.66663C9.54167 1.66663 9.16667 2.04163 9.16667 2.49996V17.5C9.16667 17.9583 9.54167 18.3333 10 18.3333ZM3.33333 11.6666C3.79167 11.6666 4.16667 11.2916 4.16667 10.8333V9.16663C4.16667 8.70829 3.79167 8.33329 3.33333 8.33329C2.875 8.33329 2.5 8.70829 2.5 9.16663V10.8333C2.5 11.2916 2.875 11.6666 3.33333 11.6666ZM13.3333 15C13.7917 15 14.1667 14.625 14.1667 14.1666V5.83329C14.1667 5.37496 13.7917 4.99996 13.3333 4.99996C12.875 4.99996 12.5 5.37496 12.5 5.83329V14.1666C12.5 14.625 12.875 15 13.3333 15ZM15.8333 9.16663V10.8333C15.8333 11.2916 16.2083 11.6666 16.6667 11.6666C17.125 11.6666 17.5 11.2916 17.5 10.8333V9.16663C17.5 8.70829 17.125 8.33329 16.6667 8.33329C16.2083 8.33329 15.8333 8.70829 15.8333 9.16663Z",
    fill: "#3367CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisio);
export default __webpack_public_path__ + "static/media/visio.0a67c8c5.svg";
export { ForwardRef as ReactComponent };